import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <path d="M9.68,19.67l-6-6.57,2.12-1.92,3.85,4.24,8.85-9.75,2.12,1.92Z" />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Tick.jsx